<template>
    <Modal ref="modal"
           :title="modalTitle"
           :hideFooter="true"
           :large="true">


        <template v-slot:body>

            <div class="card-body">
                <div class="row">



                    <div v-if="task.customer"
                         class="mb-3">

                        <div v-for="contact in task.customer.contacts"
                             style="display:inline-block;margin-left:20px;">
                            <img class='eventTooltipContactImage'
                                 @error="$handlers.customerHandler.onContactImageError($event, contact)"
                                 :src="$handlers.customerHandler.getContactImage(contact)">
                            <router-link :to="`/customer/${task.customer.id}`"
                                         @click.native="$refs.modal.hide()"
                                         style="color: inherit; text-decoration: none;">
                                {{ contact.firstName }}
                                {{ contact.lastName }}
                            </router-link>
                        </div>



                        <span style="color: rgb(171, 140, 228); cursor: pointer;"
                              @click="$root.$emit('findCustomer', setCustomerAndEvent)">
                            החלף לקוח
                        </span>


                        <br>
                    </div>

                    <div v-else>

                        <span style="color: rgb(171, 140, 228); cursor: pointer;"
                              @click="$root.$emit('findCustomer', setCustomerAndEvent)">
                            הוסף לקוח
                        </span>

                    </div>


                    <!-- a new task opened from another one (משימת המשך): what it continues, and
                         whether that task closes with it -->
                    <div class="col-12 taskModalFollowUpBanner"
                         v-if="followUpOf">
                        <div>
                            <i class="fa-solid fa-arrow-turn-down"></i>
                            משימת המשך ל: <b>{{ followUpOf.name }}</b>
                            <span v-if="followUpOf.createdBy && followUpOf.createdBy.name"
                                  class="taskModalMuted">
                                (מאת {{ followUpOf.createdBy.name }})
                            </span>
                        </div>
                        <label v-if="!followUpOf.done"
                               @click="markPreviousDone = !markPreviousDone"
                               style="user-select: none;cursor:pointer;margin:6px 0 0 0;">
                            <span class="planup-checkbox planup-checkbox-purple"
                                  :class="{ checked: markPreviousDone }">
                                <i class="fa fa-check"></i>
                            </span>
                            לסמן את המשימה הקודמת כבוצעה
                        </label>
                    </div>

                    <!-- who made the task and what it continues -->
                    <div class="col-12 taskModalPeople"
                         v-if="task.id && (creatorLabel || followUpOfRow)">
                        <span v-if="creatorLabel">
                            <i :class="systemTask ? 'fa-solid fa-robot' : 'fa-regular fa-user'"></i>
                            נוצרה על ידי {{ creatorLabel }}
                            <span v-if="task.created" class="taskModalMuted">· {{ $globals.niceDate(task.created) }}</span>
                        </span>
                        <span v-if="followUpOfRow">
                            <span v-if="creatorLabel">&nbsp;·&nbsp;</span>
                            <i class="fa-solid fa-arrow-turn-down"></i>
                            המשך של
                            <span class="taskModalLink" @click="openChainTask(followUpOfRow)">{{ followUpOfRow.name }}</span>
                        </span>
                    </div>




                    <div class="col-6">
                        <div class="mb-3">
                            <label class="form-label">
                                {{ $t('taskTypes') }}
                                <span style="color:#ab8ce4;cursor:pointer;float:left"
                                      @click="$refs.QuickEditTaskTypes.show()">
                                    ניהול מהיר
                                </span>
                            </label>

                            <QuickEdit ref="QuickEditTaskTypes"
                                       :title="$t('QuickEditTaskTypes')"
                                       listName="taskTypes"
                                       controller="task-types">
                            </QuickEdit>
                            <Multiselect selectedLabel=""
                                         deselect-label=""
                                         label="name"
                                         :showNoOptions="false"
                                         track-by="id"
                                         placeholder=""
                                         selectLabel=""
                                         tagPlaceholder="הקישו אנטר ליצירת  סוג משימה חדש"
                                         :taggable="true"
                                         v-model="task.taskType"
                                         :options="$store.state.taskTypes.filter(x => !x.hidden)"
                                         @tag="$handlers.listsHandler.createListItem($event, 'taskTypes', 'task-types', task, 'taskType')">
                                <template slot="noResult">לא נמצאו תוצאות</template>
                            </Multiselect>
                        </div>
                    </div>


                    <div class="col-4"
                         v-if="false">
                        <div class="mb-3">
                            <label class="form-label">
                                שיוך ללקוח / אירוע
                            </label>
                            <br>
                            <button class="btn btn-primary"
                                    @click="$root.$emit('findCustomer', setCustomerAndEvent)">
                                חיפוש
                                &nbsp;
                                <i class="fa-solid fa-magnifying-glass"></i>
                            </button>
                            <br>
                            <span>
                                {{ $globals.concatContactNames(task.customer) }}
                                &nbsp;
                                &nbsp;
                                &nbsp;
                                {{ task.event && task.event.eventClass ? task.event && task.event.eventClass.name : ''
                                }}
                                {{ task.event && task.event.date ? $globals.niceDate(task.event.date) : '' }}

                            </span>
                        </div>
                    </div>








                    <div class="col-6">
                        <div class="mb-3">
                            <label class="form-label">
                                שם
                            </label>
                            <input v-model="task.name"
                                   class=form-control>
                        </div>
                    </div>

                    <div class="col-3">
                        <div class="mb-3">
                            <label class="form-label">
                                תאריך
                            </label>


                            <EventDatePicker :tabs="[1]"
                                             :placeHolder="$globals.niceDate(task.date)"
                                             ref="datePicker"
                                             @setTime="task.time = $event"
                                             @singleDate="task.date = $event"></EventDatePicker>
                        </div>
                    </div>

                    <div class="col-3">
                        <div class="mb-3">
                            <label class="form-label">
                                שעה
                            </label>
                            <div>


                                <WheelTimePicker v-model="task.time"></WheelTimePicker>




                            </div>
                        </div>
                    </div>


                    <div class="col-6">
                        <div class="mb-3">
                            <label class="form-label">
                                {{ $t('crewMembers') }}
                                <span style="color:#ab8ce4;cursor:pointer;float:left"
                                      @click="$refs.QuickEditCrewMembers.show()">
                                    ניהול מהיר
                                </span>
                            </label>

                            <QuickEdit ref="QuickEditCrewMembers"
                                       :title="$t('QuickEditCrewMembers')"
                                       listName="crewMembers"
                                       controller="crew-members">
                            </QuickEdit>
                            <Multiselect selectedLabel=""
                                         deselect-label=""
                                         label="name"
                                         track-by="id"
                                         :multiple="true"
                                         placeholder=""
                                         selectLabel=""
                                         tagPlaceholder="הקישו אנטר ליצירת איש צוות חדש"
                                         :taggable="true"
                                         v-model="task.crewMembers"
                                         :options="$store.state.crewMembers.filter(x => !x.hidden)"
                                         @tag="$handlers.listsHandler.createListItem($event, 'crewMembers', 'crew-members', task, 'crewMembers', true)">
                                <template slot="noResult">לא נמצאו תוצאות</template>
                                <template slot="noOptions">אין אפשרויות</template>
                            </Multiselect>
                        </div>
                    </div>


                    <div class="col-3">
                        <div class="mb-3">
                            <label class="form-label">
                                עדיפות
                            </label>
                            <Multiselect v-model="task.priority"
                                         :options="['נמוך', 'בינוני', 'גבוה']"
                                         placeholder=""
                                         selectLabel=""
                                         selectedLabel=""
                                         deselect-label="">
                                <template slot="noResult">לא נמצאו תוצאות</template>
                                <template slot="noOptions">אין אפשרויות</template>
                            </Multiselect>



                        </div>
                    </div>

                    <!-- the user the task is for: any user of the account. The chips hand it to me,
                         or back to whoever gave the task (this one, or the one a follow-up continues) -->
                    <div class="col-6">
                        <div class="mb-3 taskModalAssignee">
                            <label class="form-label">
                                מוקצה ל
                            </label>
                            <Multiselect v-model="task.assignedTo"
                                         :options="$store.state.taskAssignees"
                                         label="name"
                                         track-by="id"
                                         :custom-label="userLabel"
                                         placeholder="לא הוקצה למשתמש"
                                         selectLabel=""
                                         selectedLabel=""
                                         deselect-label="">
                                <template slot="noResult">לא נמצאו תוצאות</template>
                                <template slot="noOptions">אין אפשרויות</template>
                            </Multiselect>
                            <div class="taskModalAssigneeChips">
                                <span class="taskModalChip taskModalChipMe"
                                      v-if="me && me.id && !isAssignedTo(me.id)"
                                      @click="assignTo(me)">
                                    אליי
                                </span>
                                <span class="taskModalChip taskModalChipGiver"
                                      v-if="giver && !isAssignedTo(giver.id)"
                                      @click="assignTo(giver)">
                                    חזרה אל {{ giver.name }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div style="position:relative;">


                        <label @click="task.done = !task.done"
                               class="taskModalDone"
                               style="user-select: none;cursor:pointer">
                            <span class="planup-checkbox planup-checkbox-purple"
                                  style="user-select: none;"
                                  :class="{ checked: task.done }">
                                <i class="fa fa-check"></i>

                            </span>
                            בוצע
                        </label>

                        &nbsp;
                        &nbsp;
                        &nbsp;

                        <label @click="task.showInCalendar = !task.showInCalendar"
                               style="user-select: none;cursor:pointer">
                            <span class="planup-checkbox planup-checkbox-purple"
                                  style="user-select: none;"
                                  :class="{ checked: task.showInCalendar }">
                                <i class="fa fa-check"></i>

                            </span>
                            הצג ביומן
                        </label>



                        &nbsp;
                        &nbsp;
                        &nbsp;



                        <label @click="task.recurrence.on = !task.recurrence.on"
                               style="user-select: none;cursor:pointer">
                            <span class="planup-checkbox planup-checkbox-purple"
                                  style="user-select: none;"
                                  :class="{ checked: task.recurrence.on }">
                                <i class="fa fa-check"></i>
                            </span>

                            משימה חוזרת
                        </label>





                        <div v-show="task.recurrence.on">


                            <br>


                            <div class="mb-3">

                                <label style="width:80px">
                                    חזרה כל
                                </label>




                                <input type="number"
                                       class="form-control"
                                       style="width: 80px;display:inline-block"
                                       v-model="task.recurrence.repeatDelta"
                                       value=1>

                                &nbsp;

                                <Multiselect selectedLabel=""
                                             style="width: 120px;display:inline-block;display:inline-block;position:relative;top:2px;vertical-align: bottom;"
                                             deselect-label=" "
                                             label="name"
                                             placeholder=" "
                                             selectLabel=" "
                                             v-model="task.recurrence.repeatType"
                                             :options="$store.state.taskRecurrenceRepeatTypes">
                                    <template slot="noResult">לא נמצאו תוצאות</template>
                                    <template slot="noOptions">אין אפשרויות</template>
                                </Multiselect>


                            </div>





                            <div class="mb-3"
                                 style="display:none">

                                <br>

                                <div class="mb-2">
                                    חזרה בימים

                                    <span style="color:red">
                                        לא התיחסתי לימים בשבוע
                                    </span>
                                </div>

                                <span style="width:27px;display:inline-block">

                                </span>


                                <span @click="task.recurrence.days.sun = !task.recurrence.days.sun"
                                      class="dayOfWeekToggle"
                                      :class="{ chosen: task.recurrence.days.sun }">
                                    א'
                                </span>

                                &nbsp;

                                <span @click="task.recurrence.days.mon = !task.recurrence.days.mon"
                                      class="dayOfWeekToggle"
                                      :class="{ chosen: task.recurrence.days.mon }">
                                    ב'
                                </span>

                                &nbsp;

                                <span @click="task.recurrence.days.tue = !task.recurrence.days.tue"
                                      class="dayOfWeekToggle"
                                      :class="{ chosen: task.recurrence.days.tue }">
                                    ג'
                                </span>

                                &nbsp;

                                <span @click="task.recurrence.days.wed = !task.recurrence.days.wed"
                                      class="dayOfWeekToggle"
                                      :class="{ chosen: task.recurrence.days.wed }">
                                    ד'
                                </span>

                                &nbsp;

                                <span @click="task.recurrence.days.thu = !task.recurrence.days.thu"
                                      class="dayOfWeekToggle"
                                      :class="{ chosen: task.recurrence.days.thu }">
                                    ה'
                                </span>

                                &nbsp;

                                <span @click="task.recurrence.days.fri = !task.recurrence.days.fri"
                                      class="dayOfWeekToggle"
                                      :class="{ chosen: task.recurrence.days.fri }">
                                    ו'
                                </span>

                                &nbsp;

                                <span @click="task.recurrence.days.sat = !task.recurrence.days.sat"
                                      class="dayOfWeekToggle"
                                      :class="{ chosen: task.recurrence.days.sat }">
                                    ש'
                                </span>

                            </div>

                            <div>


                                סיום חזרות

                                <br>



                                <label class="planup-radio-wrapper"
                                       style="width:80px;"
                                       @click="task.recurrence.endType = 'count'">

                                    <span class="planup-radio"
                                          :class="{ checked: task.recurrence.endType == 'count' }">
                                    </span>

                                    אחרי

                                </label>


                                <input type="number"
                                       class="form-control"
                                       :class="{ disabled: task.recurrence.endType != 'count' }"
                                       style="width: 80px;display:inline-block"
                                       v-model="task.recurrence.repeatCountValue"
                                       :disabled="task.recurrence.endType != 'count'"
                                       value=1>

                                &nbsp;

                                <Multiselect selectedLabel=""
                                             style="width: 120px;display:inline-block;display:inline-block;position:relative;top:2px;vertical-align: bottom"
                                             deselect-label=" "
                                             label="name"
                                             placeholder=" "
                                             selectLabel=" "
                                             :class="{ disabled: task.recurrence.endType != 'count' }"
                                             v-model="task.recurrence.repeatCountType"
                                             :disabled="task.recurrence.endType != 'count'"
                                             :options="$store.state.taskRecurrenceRepeatCountTypes">
                                    <template slot="noResult">לא נמצאו תוצאות</template>
                                    <template slot="noOptions">אין אפשרויות</template>
                                </Multiselect>

                                <br>
                                <br>



                                <!-- <label class="planup-radio-wrapper"
                                           @click="task.recurrence.endType = 'never'">

                                        <span class="planup-radio"
                                              :class="{ checked: task.recurrence.endType == 'never' }">
                                        </span>

                                        אף פעם

                                        (עד 1,000 חזרות)

                                    </label>

                                    <br>
                                    <br> -->

                                <label class="planup-radio-wrapper"
                                       style="width:80px;"
                                       @click="task.recurrence.endType = 'date'">

                                    <span class="planup-radio"
                                          :class="{ checked: task.recurrence.endType == 'date' }">
                                    </span>

                                    בתאריך

                                </label>



                                <DatePicker v-model="task.recurrence.endDate"
                                            style="width:209px"
                                            :disabled="task.recurrence.endType != 'date'"
                                            :enableTime="false"></DatePicker>



                            </div>


                            <br>



                        </div>



                    </div>


                    <br>
                    <br>


                    <div class="col-12">
                        <div class="mb-3">
                            <label class="mb-2">
                                פרטי המשימה
                            </label>
                            <textarea v-model="task.description"
                                      style="height:200px;resize: none;"
                                      class="form-control"></textarea>
                        </div>
                    </div>


                    <div class="col-md-4"
                         v-for="cf in taskCustomFields"
                         :key="'cf' + cf.id">
                        <CustomFieldInput :field="cf" :owner="task"></CustomFieldInput>
                    </div>


                    <!-- the chain this task is one of: the task it all started with and every
                         follow-up after it, in order. A click opens that task here. -->
                    <div class="col-12 taskModalChain"
                         v-if="chain.length > 1">
                        <label class="mb-2">
                            <i class="fa-solid fa-link"></i>
                            שרשרת משימות
                            <span class="taskModalMuted">({{ chain.length }})</span>
                        </label>
                        <div class="taskModalChainList">
                            <div v-for="(row, index) in chain"
                                 :key="row.id"
                                 class="taskModalChainRow"
                                 :class="{ taskModalChainCurrent: row.id == task.id, taskModalChainDone: row.done }"
                                 :data-chain-task-id="row.id"
                                 @click="openChainTask(row)">
                                <span class="taskModalChainStep">{{ index + 1 }}</span>
                                <i class="taskModalChainCheck"
                                   :class="row.done ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle'"></i>
                                <span class="taskModalChainName">{{ row.name }}</span>
                                <span class="taskModalChainPeople">
                                    <span v-if="chainCreatorLabel(row)">מאת {{ chainCreatorLabel(row) }}</span>
                                    <span v-if="chainAssigneeLabel(row)">&nbsp;<i class="fa-solid fa-arrow-left" style="font-size:10px;"></i>&nbsp;{{ chainAssigneeLabel(row) }}</span>
                                </span>
                                <span class="taskModalChainDate">{{ $globals.niceDate(row.date) }}</span>
                            </div>
                        </div>
                    </div>


                </div>


                <div style="float:right">
                    <br>
                    <span style="cursor:pointer"
                          v-if="task.id"
                          @click="deleteTask">
                        <i class="fa-regular fa-trash-can"></i>
                        מחק משימה
                    </span>
                </div>



                <div class="pull-right taskModalButtons">
                    <br>
                    <!-- the next task in line: a new task that continues this one (for a colleague,
                         or back to whoever gave it), with this one closed on the way -->
                    <button class="btn btn-light taskModalFollowUpButton"
                            v-if="task.id"
                            @click="startFollowUp()">
                        <i class="fa-solid fa-arrow-turn-down"></i>
                        משימת המשך
                    </button>
                    <button class="btn btn-primary"
                            @click="saveTask()">
                        שמור
                    </button>
                </div>

            </div>

        </template>
    </Modal>
</template>
<script>
import EventDatePicker from '../EventDatePicker/EventDatePicker.vue';
import QuickEdit from '../QuickEdit/QuickEdit.vue';
import Multiselect from 'vue-multiselect';
import DatePicker from '../Common/DatePicker';
import WheelTimePicker from '../Common/WheelTimePicker.vue';
import { orderContactsBrideFirst } from '../../modules/contactOrdering';
import CustomFieldInput from '../CustomFields/CustomFieldInput.vue';
import { userLabel, taskCreatorLabel, taskAssigneeLabel, isSystemTask } from '../../modules/TaskPeople';


export default {

    name: 'TaskModal',

    data() {

        return {
            showRecurrencePopup: false,
            originalTask: null,
            task: this.$handlers.tasksHandler.generateLocalEmptyTask(),
            modalTitle: '',
            suppressAutoName: false,
            //the chain the open task is one of (tasks/chain): every task from the first to the last
            chain: [],
            //while a follow-up is being written: the task it continues ({ id, name, done, createdBy,
            //assignedTo }), the row object that task came from in its list (flagged done after the
            //save, so the list shows it without a reload), and the banner's checkbox
            followUpOf: null,
            previousOriginal: null,
            markPreviousDone: true,
        }
    },

    watch: {


        //auto-name the task when a task type is picked or the customer is swapped.
        //(this used to be a deep watcher on the whole task, which clobbered any typed
        //name on every keystroke with "undefined - <contacts>" when no type was picked)
        'task.taskType': function () {
            this.autoNameTask();
        },

        'task.customer': function () {
            this.autoNameTask();
        },



    },
    methods: {

        userLabel: userLabel,

        autoNameTask() {

            //don't rename while show() swaps the whole task object in
            if (this.suppressAutoName)
                return;

            if (!this.task.customer || !this.task.taskType || !this.task.taskType.name)
                return;

            let customerBrideFirst = { ...this.task.customer, contacts: orderContactsBrideFirst(this.task.customer.contacts) };
            this.task.name = this.task.taskType.name + ' - ' + this.$globals.concatContactNames(customerBrideFirst);
        },

        async saveTask() {

            //a follow-up closes the task it continues when the banner's box is ticked (the server
            //marks it, and tells whoever gave it)
            let closePrevious = !!this.followUpOf && !this.followUpOf.done && this.markPreviousDone;
            if (this.followUpOf)
                this.task.markPreviousDone = closePrevious;

            let newTaskFromServer = await this.$handlers.tasksHandler.saveTask(this.task);

            delete this.task.markPreviousDone;


            //adding the task to the list we came from
            if (planup.$store.state.whereToAddTaskAfterSavingNewTask){
                planup.$store.state.whereToAddTaskAfterSavingNewTask.push(newTaskFromServer);
                planup.$store.state.whereToAddTaskAfterSavingNewTask = null;
            }

            //the list row of the task this follow-up continues shows it done, as the server has it
            if (closePrevious && this.previousOriginal)
                this.previousOriginal.done = true;

            //let open views (e.g. customer page) merge the saved task into their lists without a reload
            this.$root.$emit('taskSaved', this.task);



            this.$root.$emit('showSummonModal', {
                contacts: this.task?.customer?.contacts,
                crewMembers: this.task?.crewMembers,
                title: this.task.name,
                date: this.task.date,
                event: this.task?.event


            });

            this.$refs.modal.hide();

            //if task is a new task and is for today add it to the list
            if (this.task.date && new Date(this.task.date).toDateString() === new Date().toDateString() && !this.$store.state.tasksToday.find(x => x.id === this.task.id)) {
                this.task.created = new Date();
                this.$store.state.tasksToday.push(this.task);
            }

            //loading the new details to wherever we came from
            if (this.originalTask) {
                Object.keys(this.originalTask).forEach(key => {
                    this.originalTask[key] = this.task[key];
                });
                this.originalTask.id = this.task.id;
            }


        },

        deleteTask() {

            this.$swal({
                title: 'האם למחוק את המשימה?',
                confirmButtonText: 'כן',
                cancelButtonText: 'לא',
                confirmButtonColor: '#ab8ce4',
                showCancelButton: true,
            })
                .then(() => {

                    //lists that page on the server (the tasks page) fetch their page again
                    let deletedTask = this.task;
                    this.$handlers.tasksHandler.deleteTask(deletedTask.id).then(() => this.$root.$emit('taskDeleted', deletedTask));
                    this.$refs.modal.hide();

                    this.task.hidden = true;
                    if (this.originalTask)
                        this.originalTask.hidden = true;

                })



        },

        show(task) {

            this.originalTask = task;
            this.followUpOf = null;
            this.previousOriginal = null;

            this.applyTask(task ? deepCopy(task) : this.$handlers.tasksHandler.generateLocalEmptyTask(), 'משימה חדשה');
        },

        //puts a task in the form (the modal is opened if it isn't). The title is the task's name;
        //a new task has none yet
        applyTask(task, title) {

            //the task swap below re-triggers the taskType/customer watchers - not a user edit
            this.suppressAutoName = true;

            this.task = task;

            //the fields the form binds to must exist on the task for Vue to follow them - a task
            //from a list, or from before the assignee existed, may carry none of them
            if (typeof this.task.assignedTo === 'undefined') this.$set(this.task, 'assignedTo', null);
            if (typeof this.task.done === 'undefined') this.$set(this.task, 'done', false);

            //the form reads every recurrence field (days.sun...), but a task that wasn't made here
            //(a seeded or imported row) can carry none, or just {"on": false} - the render threw
            let emptyRecurrence = this.$handlers.tasksHandler.generateLocalEmptyTask().recurrence;
            let recurrence = Object.assign({}, emptyRecurrence, this.task.recurrence);
            if (!recurrence.days)
                recurrence.days = emptyRecurrence.days;
            this.$set(this.task, 'recurrence', recurrence);

            //deepcopy not make date objects
            if (this.task.date)
                this.task.date = new Date(this.task.date);

            if (this.task.description) {

                this.task.description = this.task.description.replace(/\<br\>/, '\n');
                this.task.description = this.task.description.replace(/<\/?[^>]+(>|$)/g, "");
            }



            this.modalTitle = this.task.name ? this.task.name : title;
            this.$refs.modal.show();

            //the users a task can be handed to, and the chain this task is one of
            this.$handlers.tasksHandler.loadAssignees().catch(e => console.error('task assignees', e));
            this.loadChain();

            //registered after the task assignment so the watcher flush (queued at assignment
            //time) runs before this clears the flag
            this.$nextTick(() => { this.suppressAutoName = false });
        },

        //the chain of the open task (one row = the task alone; the section shows from two)
        loadChain() {

            this.chain = [];

            let id = this.task.id;
            if (!id)
                return;

            this.$handlers.tasksHandler.getChain(id).then(rows => {
                if (this.task.id === id && Array.isArray(rows))
                    this.chain = rows;
            }).catch(e => console.error('task chain', e));
        },

        //a task of the chain, opened here instead of the one shown
        openChainTask(row) {

            if (!row || !row.id || row.id === this.task.id)
                return;

            this.$handlers.tasksHandler.getTask(row.id).then(task => this.show(task));
        },

        //the next task in line: a new task that continues the one shown - same customer / event /
        //type, handed by default back to whoever gave this one (when that is someone else)
        startFollowUp() {

            let previous = this.task;
            if (!previous.id)
                return;

            this.previousOriginal = this.originalTask;
            this.originalTask = null;

            this.followUpOf = {
                id: previous.id,
                name: previous.name,
                done: !!previous.done,
                createdBy: previous.createdBy || null,
                assignedTo: previous.assignedTo || null
            };
            this.markPreviousDone = !previous.done;

            let next = this.$handlers.tasksHandler.generateLocalEmptyTask();
            next.customer = previous.customer || null;
            next.event = previous.event || null;
            next.taskType = previous.taskType || null;
            next.priority = previous.priority || null;
            next.crewMembers = Array.isArray(previous.crewMembers) ? previous.crewMembers.slice() : [];
            next.showInCalendar = previous.showInCalendar !== false;
            next.name = 'המשך: ' + (previous.name || '');
            next.followUpOfId = previous.id;

            let giver = previous.createdBy;
            next.assignedTo = giver && giver.id && this.me && giver.id != this.me.id ? { id: giver.id, name: giver.name, type: giver.type } : null;

            this.applyTask(next, 'משימת המשך');
            this.modalTitle = 'משימת המשך';
        },

        isAssignedTo(userId) {
            return !!this.task.assignedTo && this.task.assignedTo.id == userId;
        },

        assignTo(user) {
            this.$set(this.task, 'assignedTo', { id: user.id, name: user.name, type: user.type });
        },

        chainCreatorLabel: taskCreatorLabel,
        chainAssigneeLabel: taskAssigneeLabel,

        setCustomerAndEvent(searchResult) {



            // alert('we have a search result not a customer here');

            this.$handlers.customerHandler.getMinimalData(searchResult.customerId).then(customer => this.task.customer = customer);

            if (searchResult.eventId)
                this.task.event = { id: searchResult.eventId };

        }
    },
    computed: {
        taskCustomFields() {
            return (this.$store.state.customFieldDefinitions || []).filter(function(d) {
                return d.appliesTo === 'task' && !d.isHidden;
            });
        },

        me() {
            return this.$store.state.user;
        },

        //"מאת": the user who made the open task, or the part of the system that did
        creatorLabel() {
            return taskCreatorLabel(this.task);
        },

        systemTask() {
            return isSystemTask(this.task);
        },

        //the chain's row of the task this one continues (the "המשך של" line)
        followUpOfRow() {
            let id = this.task.followUpOfId;
            return id ? this.chain.find(row => row.id == id) || null : null;
        },

        //whoever gave the task - the one a follow-up continues, or the open one - when that is
        //someone else (the "חזרה אל" chip)
        giver() {
            let source = this.followUpOf ? this.followUpOf : (this.task.id ? this.task : null);
            let giver = source && source.createdBy;
            return giver && giver.id && this.me && giver.id != this.me.id ? giver : null;
        }
    },

    components: { EventDatePicker, QuickEdit, Multiselect, DatePicker, WheelTimePicker, CustomFieldInput }
}
</script>

<style scoped>
.taskModalMuted {
    color: #999;
    font-size: 12px;
}

.taskModalLink {
    color: #7650c4;
    cursor: pointer;
}

.taskModalLink:hover {
    text-decoration: underline;
}

/* who made the task / what it continues */
.taskModalPeople {
    font-size: 13px;
    color: #666;
    margin-bottom: 14px;
}

.taskModalPeople i {
    color: #ab8ce4;
    margin-left: 3px;
}

/* a follow-up being written: what it continues */
.taskModalFollowUpBanner {
    background: #f4f0fc;
    border-right: 3px solid #ab8ce4;
    border-radius: 4px;
    padding: 10px 12px;
    margin-bottom: 16px;
    font-size: 14px;
}

.taskModalFollowUpBanner > div > i {
    color: #7650c4;
    margin-left: 4px;
}

/* the assignee's quick picks */
.taskModalAssigneeChips {
    margin-top: 6px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.taskModalChip {
    border: 1px solid #ddd;
    background: #fff;
    border-radius: 20px;
    padding: 2px 10px;
    font-size: 12px;
    color: #555;
    cursor: pointer;
    user-select: none;
}

.taskModalChip:hover {
    border-color: #ab8ce4;
    color: #7650c4;
}

/* the chain */
.taskModalChain {
    margin-top: 6px;
}

.taskModalChain > label i {
    color: #ab8ce4;
}

.taskModalChainList {
    border: 1px solid #eee;
    border-radius: 6px;
    overflow: hidden;
}

.taskModalChainRow {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 10px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    font-size: 13px;
}

.taskModalChainRow:last-child {
    border-bottom: none;
}

.taskModalChainRow:hover {
    background: #faf8ff;
}

.taskModalChainCurrent {
    background: #f4f0fc;
    font-weight: 600;
    cursor: default;
}

.taskModalChainCurrent:hover {
    background: #f4f0fc;
}

.taskModalChainStep {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #e9e6ff;
    color: #4b3fd6;
    font-size: 11px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.taskModalChainCheck {
    color: #bbb;
    flex-shrink: 0;
}

.taskModalChainDone .taskModalChainCheck {
    color: #4caf50;
}

.taskModalChainDone .taskModalChainName {
    text-decoration: line-through;
    color: #999;
}

.taskModalChainName {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.taskModalChainPeople {
    color: #777;
    font-size: 12px;
    font-weight: normal;
    white-space: nowrap;
}

.taskModalChainDate {
    color: #999;
    font-size: 12px;
    font-weight: normal;
    white-space: nowrap;
}

.taskModalButtons .btn + .btn {
    margin-right: 8px;
}

.taskModalFollowUpButton i {
    margin-left: 4px;
}

@media (max-width: 575px) {
    .taskModalChainPeople {
        display: none;
    }
}
</style>
